import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { toUpper } from "lodash";
import { Table, Checkbox, Popup, Label, Icon, Header, Dropdown, DropdownMenu } from "semantic-ui-react";
import { formatMoney, formatMoneyWithCurrency, toMoney } from "../../../../utils/formatter";
import LoadingSpinner from "../../../general/js/spinnerLoading";
import moment, { duration } from "moment";

import "./tableDetail.scss";
import { documentsDic } from "../../../../utils/dataDictionary";
import { CurrencyIcon } from "src/utils/currencyIcon";
import { exchange } from "src/utils/indicators";
import { GetIndicators } from 'src/graphql/indicators'
import { banksFormat, formatBanks } from "src/utils/bankList";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { importNewModal } from 'src/redux/actions/newModal'
import { ClassifyDtes, UpdateDocumentsCashflowAreaId } from "src/graphql/documents";
import { importOpenSidebar } from "src/redux/actions/openSidebar";
import { importAlertState } from "src/redux/actions/alert";
import { importUpdateCashflowNeeded } from "src/redux/actions/flujocaja";
import { PayoffModal } from "src/components/modal/flow/payoff";
import { PartialPayoffModal } from "src/components/modal/flow/partialPayoff";
import { ChequePayoff } from "src/components/modal/flow/chequePayoff";
import { PostponeModal } from "src/components/modal/flow/postpone";
import { RevertPayoff } from "src/components/modal/flow/revertPayoff";
import { EditAreaModal } from "src/components/modal/flow/editArea";
import { GetDropdownOptions } from "../rowDetail/functions";
import { useBlockedFeatures } from "src/hooks/useBlockedFeatures";

const top = -25;

const isProjectionType = (document) => {
  const projectionTypes = ['proyeccion', 'estimaciondeingreso', 'estimaciondeegreso'];
  return projectionTypes.includes(document?.meta?.type);
};

export default function TableDetail({
  data,
  loading,
  filterPoint,
  setSelected,
  selected,
  totalSelected,
  setTotalSelected,
  selectAll,
  setSelectAll,
  openSidebar,
  settledPointsView,
  companyId,
  value,
  type,
  pointType,
  showCompanyColumn = false,
  companyNameById = {},
}) {
  const { t } = useTranslation("finance");
  const getDocumentCompanyId = (document) =>
    document?.companyId || document?.meta?.companyId || document?.document?.companyId || document?.document?.meta?.companyId;

  const getDocumentCompanyName = (document) => {
    const docCompanyId = getDocumentCompanyId(document);
    if (docCompanyId && companyNameById[String(docCompanyId)]) return companyNameById[String(docCompanyId)];
    return document?.companyName || document?.meta?.companyName || document?.document?.companyName || document?.document?.meta?.companyName || "-";
  };


  const dispatch = useDispatch()
  const { abonarBlocked } = useBlockedFeatures()
  const history = useHistory()
  const location = useLocation()
  const updateDocumentsCashflowAreaId = UpdateDocumentsCashflowAreaId()

  //Obtención de idicadores.
  const Indicators = GetIndicators()

  //Si la query fue ejecutada de forma correcta, se obtienen indicadores, de lo contrario null
  const pepperExchange = Indicators?.data?.getIndicators?.exchange

  if (!data || loading)

    return (
      <div className="flowSpinner">
        <LoadingSpinner
          height="60px"
          afterHeight="60px"
          afterWidth="60px"
        />
      </div>
    );


  const filteredData = data?.filter(
    (f) =>
      (toUpper(f?.document?.meta?.receiverId).includes(toUpper(filterPoint)) ||
        toUpper(f?.document?.meta?.issuerId).includes(toUpper(filterPoint)) ||
        toUpper(f?.document?.meta?.issuerName).includes(toUpper(filterPoint)) ||
        toUpper(f?.document?.meta?.receiverName).includes(toUpper(filterPoint)) ||
        (showCompanyColumn && toUpper(getDocumentCompanyName(f)).includes(toUpper(filterPoint)))) && f
  )

  // Seleccion masiva de documentos
  const SelectMasive = () => {
    let docsSelecteds = []
    let updatedTotalSelected = { ...totalSelected };

    data.map((doc, index) => {

      if (!selectAll) {
        doc.selected = true
        const isCLP = doc.currencyType === 'CLP'
        const isCredit = doc.documentType === 'CREDIT'
        const remainingCLP = isCLP ? doc.meta.remaining : doc.meta.remaining * pepperExchange[doc.currencyType];
        // const originalAmountCLP = isCLP ? doc.meta.originalAmount : doc.meta.originalAmount * pepperExchange[doc.currencyType];
        const originalAmountCLP = isCLP
          ? (isCredit ? doc.amount : doc.meta.originalAmount)
          : (isCredit ? doc.amount : doc.meta.originalAmount) * pepperExchange[doc.currencyType];
        // const isObligation = doc.documentType === 'OBLIGATION'
        const isPaid = doc.meta.isPaid;
        const isNC = [61, 112, '61', '112'].includes(doc?.meta?.documentCode)
        // let pointPesos = Math.round((isNC ? -1 : 1) * (isCLP ? doc.meta.remaining : (isObligation ? doc.meta.amount : doc.meta.remaining))) //fix para UF
        // let pointPesos = Math.round((isNC ? -1 : 1) * (isPaid ? 0 : doc.meta.remaining));
        let pointPesos = Math.round((isNC ? -1 : 1) * (isPaid ? originalAmountCLP : remainingCLP));

        const index = selected.findIndex((find) => find === doc);
        if (index === -1) {
          updatedTotalSelected = {
            ...updatedTotalSelected,
            amount: isNaN(updatedTotalSelected?.amount)
              ? parseInt(pointPesos)
              : updatedTotalSelected?.amount + pointPesos,
          };
          docsSelecteds.push(doc)
          setSelected([...selected, ...docsSelecteds]);
        }
      } else {
        doc.selected = false
        const index = selected.findIndex((find) => find === doc);
        selected.splice(index, 1);
        docsSelecteds.splice(index, 1);
        updatedTotalSelected = 0
      }

    })
    setTotalSelected(updatedTotalSelected)
    setSelectAll(!selectAll);

  }

  const onClick = (v, document) => {
    const isCLP = document.currencyType === 'CLP'
    const isCredit = document.documentType === 'CREDIT'
    const remainingCLP = isCLP ? document.meta.remaining : document.meta.remaining * pepperExchange[document.currencyType];
    const originalAmountCLP = isCLP
      ? (isCredit ? document.amount : document.meta.originalAmount)
      : (isCredit ? document.amount : document.meta.originalAmount) * pepperExchange[document.currencyType];
    // const isObligation = document.documentType === 'OBLIGATION'
    const isPaid = document.meta.isPaid;
    const isNC = [61, 112, '61', '112'].includes(document?.meta?.documentCode)
    /**
     * Se agrega pepperExchange,  que son los indicadores diarios provenientes de Pepper
     * En caso contrario se usarán los definidos en el proyecto.
     */
    // let pointPesos = Math.floor((isNC ? -1 : 1) * (document.meta.remaining) * pepperExchange[document.currencyType] || exchange[document.currencyType])  //fix para UF
    let pointPesos = Math.round((isNC ? -1 : 1) * (isPaid ? originalAmountCLP : remainingCLP));
    document.selected = v.checked
    if (v.checked) {

      setTotalSelected({
        ...totalSelected,
        amount: isNaN(totalSelected?.amount)
          ? parseInt(pointPesos)
          : totalSelected?.amount + pointPesos,
      });

      setSelected([...selected, document]);

    } else {
      setTotalSelected({
        ...totalSelected,
        amount: totalSelected?.amount - pointPesos,
      });

      const index = selected.findIndex((find) => find === document);
      selected.splice(index, 1);
      setSelectAll(false);
    }
  };

  //Función que revisa si activar o no el check.
  const isChecked = ({ id }) => {
    const isIncluded = selected.find((f) => f.id === id)
    if (isIncluded) return true
    return false
  }


  const getOpacity = (document) => {
    if (document.meta.isPaid) {
      if (document.meta?.factoring?.cedido == true) return 0.5;
      return document.meta?.matchs?.inMatch?.some(match => match.obligationType === 'factoring' || match.obligationType === 'cheque' || match.obligationType === 'cheques_por_pagar') ? 0.5 : 1;
    }
  }

  const OptionsDropDown = (values) => {
    const wrapperRef = useRef(null);
    const [cssVars, setCssVars] = useState({});

    const handleOpen = () => {
      if (!wrapperRef.current) return;
      const rect = wrapperRef.current.getBoundingClientRect();
      setCssVars({
        '--dd-fixed-bottom': `${window.innerHeight - rect.top}px`,
        '--dd-fixed-right': `${window.innerWidth - rect.right}px`,
      });
    };

    const getDropdownOptions = GetDropdownOptions(
      type == pointType.SETTLED,
      { name: value?.label },
      [values.document]
    )

    // Conditionally include payoff options only when document is a projection type
    const shouldIncludePayoffOptions = isProjectionType(values.document);
    const filteredOptions = getDropdownOptions?.filter(option => {
      const isPayoffOption = ['payoff', 'partialPayoff', 'chequePayoff', 'revertPayoff'].includes(option.value);
      const isAbonoPayoff = ['payoff', 'partialPayoff', 'chequePayoff'].includes(option.value);
      if (abonarBlocked && isAbonoPayoff) return false;
      return !isPayoffOption || shouldIncludePayoffOptions;
    })

    return (
      <div ref={wrapperRef} className="threeDotFixedMenu" style={cssVars}>
      <Dropdown icon={<Icon name="ellipsis vertical" />} direction="left" onOpen={handleOpen}>
        <DropdownMenu>
          {filteredOptions?.map((option) => {
            if (option.value === 'postpone') return <PostponeModal companyId={companyId} option={option} selected={[values.document]} />
            if (option.value === 'editArea') return <EditAreaModal companyId={companyId} option={option} selected={[values.document]} />

            if (option.value === 'editManual') return (
              <Dropdown.Item
                value={option?.value}
                onClick={() => {
                  dispatch(
                    importOpenSidebar({
                      show: true,
                      createObligation: true,
                      editData: [values.document][0],
                      source: 'editObligation'
                    })
                  )
                }
                }
              > {option?.text}
              </Dropdown.Item>
            )

            // Include payoff options when document is a projection type
            if (shouldIncludePayoffOptions) {
              if (option.value === 'payoff') return <PayoffModal companyId={companyId} option={option} selected={[values.document]} />
              if (option.value === 'partialPayoff') return <PartialPayoffModal companyId={companyId} option={option} selected={[values.document]} />
              if (option.value === 'chequePayoff') return <ChequePayoff companyId={companyId} option={option} selected={[values.document]} />
              if (option.value === 'revertPayoff') return <RevertPayoff companyId={companyId} option={option} selected={[values.document]} />
            }

            return <div></div>
          })}
          <Dropdown.Item
            value="ocultar"
            onClick={() => OpenFCHideModal(values)}
          >
            {t("cashflowAreaDetail.hide")}
          </Dropdown.Item>
        </DropdownMenu>
      </Dropdown>
      </div>
    )
  }

  const OpenFCHideModal = ({ document }) => {
    const showModal = {
      show: true,
      title: t("cashflowAreaDetail.hideDocument"),
      confirmButtonIconRight: `chevron right`,
      size: 'tiny',
      onConfirm: () => { },
      onCancelText: t("cashflowAreaDetail.close"),
      onConfirmText: t("cashflowAreaDetail.applyChanges")
    }


    let description = `${getUpperLine(document)} por ${document.amount ? `$${document.amount}` : ' '}`
    let name = `${document.meta.issuerId || ''} ${document.meta.receiverName || ''}`
    const children = (
      <div className="d-flex flex-column w-100 editDocumentInsideEERRAreaDetail">
        <Header as='h4' className='m-0'>{description}</Header>
        <span>{name || 'Sin información sobre el emisor/receptor'}</span>
        <div className='my-4'>Este documento no aparecerá en el Flujo de Caja. Está acción puede ser revertida desde el módulo de Documentos y el módulo de Agenda.</div>
      </div>
    )

    const onConfirm = async () => {
      let companyId = document?.companyId;
      const input = {
        documentsIds: [document?.id || document?._id],
        cashflowAreaId: null,
        companyId
      }

      const { data, error } = await updateDocumentsCashflowAreaId.executeMutation({ input })

      dispatch(importNewModal({ show: false }))

      if (data) {

        dispatch(importOpenSidebar({ show: false }))

        dispatch(
          importAlertState({
            content: 'Se ha quitado la clasificación de forma exitosa.',
            state: "success",
            duration: 4,
          })
        );

        dispatch(importUpdateCashflowNeeded({ value: true, reload: null }))
      }
      if (error) {
        dispatch(
          importAlertState({
            content: `Ha ocurrido un error, por favor vuelve a intentarlo en unos minutos.`,
            state: "error",
            duration: 5,
          })
        )
      }
    }

    showModal.children = children
    showModal.onConfirm = onConfirm

    dispatch(importNewModal(showModal))
  }

  /**
   * Extract description from meta.description (for TAX_DOCUMENT) or meta.detail (for OBLIGATIONS)
   * If both name and description exist in detail, concatenate them (name first, then description)
   * If only one exists, show that one
   * If neither exists, return ''
   * If array has more than 1 element, append "... (y X items más)" to indicate more items
   */
  const getDescription = (document) => {
    const { documentType, meta } = document;
    
    // For TAX_DOCUMENT, check if meta.description is a string or an array
    if (documentType === "TAX_DOCUMENT" && meta?.description) {
      // If it's a string, return it directly
      if (typeof meta.description === 'string') {
        return meta.description;
      }
      
      // If it's an array, process it similar to OBLIGATION detail
      if (Array.isArray(meta.description) && meta.description.length > 0) {
        const firstItem = meta.description[0];
        const name =
          typeof firstItem?.name === 'string' ? firstItem.name.trim() : '';
        const desc =
          typeof firstItem?.description === 'string'
            ? firstItem.description.trim()
            : '';
        
        let result = '';
        
        // If both exist, concatenate them (name first, then description)
        if (name && desc) {
          result = `${name} ${desc}`;
        } else if (name) {
          // If only name exists, show that one
          result = name;
        } else if (desc) {
          // If only description exists, show that one
          result = desc;
        }
        // If neither exists, result remains empty string
        
        // If array has more than 1 element, append "... (y X items más)" where X is the count of additional items
        if (meta.description.length > 1 && result) {
          const additionalItemsCount = meta.description.length - 1;
          const itemText = additionalItemsCount === 1 ? 'item' : 'items';
          result = `${result}... (y ${additionalItemsCount} ${itemText} más)`;
        }
        
        return result;
      }
    }
    
    // For OBLIGATION, check meta.detail array
    if (documentType === "OBLIGATION") {
      const detail = meta?.detail;
      if (Array.isArray(detail) && detail.length > 0) {
        // Get the first item's name and description fields
        const firstItem = detail[0];
        const name =
          typeof firstItem?.name === 'string' ? firstItem.name.trim() : '';
        const desc =
          typeof firstItem?.description === 'string'
            ? firstItem.description.trim()
            : '';
        
        let result = '';
        
        // If both exist, concatenate them (name first, then description)
        if (name && desc) {
          result = `${name} ${desc}`;
        } else if (name) {
          // If only name exists, show that one
          result = name;
        } else if (desc) {
          // If only description exists, show that one
          result = desc;
        }
        // If neither exists, result remains empty string
        
        // If array has more than 1 element, append "... (y X items más)" where X is the count of additional items
        if (detail.length > 1 && result) {
          const additionalItemsCount = detail.length - 1;
          const itemText = additionalItemsCount === 1 ? 'item' : 'items';
          result = `${result}... (y ${additionalItemsCount} ${itemText} más)`;
        }
        
        return result;
      }
    }
    
    return '';
  };

  const getUpperLine = (document) => {
    const { documentType, name, meta } = document;
    
    // Get issuer/receiver name based on isReceived
    const issuerReceiverName = meta?.isReceived 
      ? meta?.issuerName 
      : meta?.receiverName;
    
    // Handle CREDIT documents
    if (documentType === "CREDIT") {
      const bankName = banksFormat[name] || '';
      const creditLabel = bankName ? `${bankName} - Crédito` : 'Crédito';
      const documentInfo = `${creditLabel} ${meta.identificator || ''}`;
      return issuerReceiverName ? `${documentInfo} - ${issuerReceiverName}` : documentInfo;
    }
    
    // Handle PAYMENT documents
    if (documentType === "PAYMENT") {
      const documentInfo = "Abono";
      return issuerReceiverName ? `${documentInfo} - ${issuerReceiverName}` : documentInfo;
    }
    
    // Handle MANUAL documents (projections)
    if (documentType === "MANUAL") {
      const documentInfo = name || "Proyección sin nombre";
      return issuerReceiverName ? `${documentInfo} - ${issuerReceiverName}` : documentInfo;
    }
    
    // Handle OBLIGATION documents
    if (documentType === "OBLIGATION") {
      let documentLabel = meta?.typeLabel || "Obligación";
      // Corregir label para estimaciones mal clasificadas (ingreso guardado como egreso)
      if (meta?.type === 'estimaciondeegreso' && openSidebar?.isReceived === false) {
        documentLabel = 'Estimación de Ingreso';
      }
      const documentNumber = meta?.number || meta?.documentId;
      const numberPrefix = documentNumber ? "#" : "";
      const documentInfo = `${documentLabel} ${numberPrefix}${documentNumber || ""}`;
      return issuerReceiverName ? `${documentInfo} - ${issuerReceiverName}` : documentInfo;
    }
    
    // Handle TAX_DOCUMENT and other document types
    const documentLabel = meta?.summary || documentsDic[meta?.documentCode]?.label || "Documento";
    const documentNumber = meta?.documentId || meta?.number;
    const numberPrefix = documentNumber ? "#" : "";
    const documentInfo = `${documentLabel} ${numberPrefix}${documentNumber || ""}`;
    return issuerReceiverName ? `${documentInfo} - ${issuerReceiverName}` : documentInfo;
  }

  const handleModalData = (document) => {
    if (!document) return
    
    // Update URL to open document detail modal
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('id', document.id);
    searchParams.set('isDocumentDetail', 'true');
    history.push({
      pathname: location.pathname,
      search: searchParams.toString()
    });
  }

  return (
    <>
      <div className="d-flex flex-column position-relative mt-5 areaDetailTable">
        {data.map((document, index) => {  
          
          if (!document) return

          // Get description for TAX_DOCUMENT and OBLIGATION
          const descriptionText = getDescription(document);
          
          const lowerLine =
            document.documentType == "CREDIT"
              ? `Pago Cuota #${document.meta?.paymentNumber || 'Desconocido'}`
              : document.documentType == "PAYMENT"
                ? "Integración TRANSBANK"
                : document.documentType == "MANUAL" && document.meta.counterpartRut
                  ? document.meta.counterpartName
                  : document.documentType == "MANUAL"
                    ? document?.description || "Sin glosa ingresada"
                    : descriptionText || "Sin glosa ingresada";


          const date =
            document?.documentType == "PAYMENT"
              ? document.date
              : document?.emissionDate || document?.documentDate;


          const amountToUse =
            document.meta.isPaid == true
              ? (document.meta?.originalAmount ?? document.amount)
              : document.meta.remaining

          const amount = formatMoneyWithCurrency(amountToUse, document.currencyType) || 0
          // Solo mostrar fecha de pago si el documento está pagado (isPaid === true)
          const paymentDateValue = (document?.meta?.isPaid === true ? document?.paymentDate : document?.dueDate) || document?.dueDate
          const isReceived = document?.meta?.isReceived;

          // Estimaciones de ingreso mal guardadas como egreso: mostrar monto positivo (no negativo)
          const isCorrectedIncomeProjection = document?.meta?.type === 'estimaciondeegreso' && openSidebar?.isReceived === false;
          const amountToShow = document.meta.__typename == 'CreditsMeta'
            ? !openSidebar?.isReceived
              ? `(-${amount})`
              : `${amount}`
            : isCorrectedIncomeProjection
              ? `${amount}`
              : document.meta.isReceived && openSidebar?.isReceived !== document.meta.isReceived
                ? `(-${amount})`
                : `${amount}`

          return (
            <div className="d-flex areaDetailRow" style={{ position: "relative" }} key={document.id}>

              <div className="d-flex flex-column align-items-center justify-content-center areaDetailEmissionDate">

                <span
                  className="text-uppercase font-weight-bold position-absolute areaDetailTitle"
                  style={{ top }}
                  hidden={index > 0}
                >
                  <Popup inverted content={t("cashflowAreaDetail.selectAll")} trigger={<Checkbox checked={selectAll} onClick={() => SelectMasive()} />} />

                </span>
                <div className="d-flex flex-column align-items-center ">
                  <Checkbox checked={isChecked({ id: document.id })} onClick={(_, v) => onClick(v, document)} />
                </div>
              </div>
              <div className="d-flex w-90 ml-1" style={{ position: 'relative', gap: '12px', flex: 1, minWidth: 0 }}>

                <div className="d-flex flex-column align-items-center areaDetailEmissionDate" style={{ minWidth: '100px', flexShrink: 0 }}>

                  <span
                    className="text-uppercase font-weight-bold position-absolute areaDetailTitle"
                    style={{ top }}
                    hidden={index > 0}
                  >
                    {t("cashflowAreaDetail.issueDate")}
                  </span>
                  <div className="d-flex align-items-center justify-content-center w-100" style={{ opacity: getOpacity(document) }}>
                    <div className="text-center text-uppercase w-100">
                      {moment(date).format("DD/MM/YYYY")}
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-column align-items-center areaDetailEmissionDate" style={{ minWidth: '100px', flexShrink: 0 }}>
                  <span
                    className="text-uppercase font-weight-bold position-absolute areaDetailTitle"
                    style={{ top }}
                    hidden={index > 0}
                  >
                    {document.documentType == "PAYMENT"
                      ? t("cashflowAreaDetail.collection")
                      : openSidebar?.isReceived
                        ? t("cashflowAreaDetail.payment")
                        : t("cashflowAreaDetail.collection")}
                  </span>

                  <div className="d-flex align-items-center justify-content-center w-100" style={{ opacity: getOpacity(document) }}>
                    <div className="text-center text-uppercase w-100">
                      {paymentDateValue 
                        ? moment(paymentDateValue).format("DD/MM/YYYY")
                        : "-"}
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-column align-items-start areaDetailProvider" style={{ flex: 1, minWidth: 0 }}>
                  <span
                    className="text-uppercase font-weight-bold position-absolute areaDetailTitle"
                    style={{ top }}
                    hidden={index > 0}
                  >
                    {t("cashflowAreaDetail.counterparty")}
                  </span>
                  <div className="tw-cursor-pointer tw-w-full" onClick={() => handleModalData(document)}>
                    <div className="areaDetailUpperLine tripleDot" style={{ opacity: getOpacity(document) }}>{getUpperLine(document)}</div>
                    <div className="tw-w-full tripleDot" style={{ opacity: getOpacity(document) }}>{lowerLine}</div>
                  </div>
                </div>
                {showCompanyColumn && (
                  <div className="d-flex flex-column align-items-start areaDetailProvider" style={{ minWidth: '130px', maxWidth: '170px', flexShrink: 0 }}>
                    <span
                      className="text-uppercase font-weight-bold position-absolute areaDetailTitle"
                      style={{ top }}
                      hidden={index > 0}
                    >
                      {t("cashflowAreaDetail.company")}
                    </span>
                    <div className="tripleDot" style={{ opacity: getOpacity(document), width: '100%' }}>
                      {getDocumentCompanyName(document)}
                    </div>
                  </div>
                )}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0, position: 'relative' }}>
                  <div className="d-flex flex-column align-items-end justify-content-center areaDetailAmount" style={{ position: 'relative' }}>
                    <span
                      className="text-uppercase font-weight-bold position-absolute areaDetailTitle"
                      style={{ top: -35, right: 0 }}
                      hidden={index > 0}
                    >
                      {t("cashflowAreaDetail.amount")}
                    </span>
                    <div style={{ opacity: getOpacity(document), display: 'flex', alignItems: 'center', gap: '6px', justifyContent: 'flex-end' }}>
                      {amountToShow}
                      {
                        document.meta.isPaid &&
                        <>
                        {(document.meta?.type === "proyeccion" || document.meta?.type === 'estimaciondeingreso' || document.meta?.type === 'estimaciondeegreso') && (
                          <Popup
                            content="Estimación"
                            trigger={
                              <Label color="red" size="mini" style={{ margin: 0, flexShrink: 0 }}>E</Label>
                            }
                          />
                        )}
                        </>
                      }
                    </div>
                  </div>

                  <div>
                    {
                      document.meta.isPaid &&
                      <>
                        {document.meta?.matchs?.inMatch?.some(match => match.obligationType === 'cheque' || match.obligationType === 'cheques_por_pagar' ) && <Label color="green" size="mini" floating style={{ left: "82%", top: "30%" }}>Pagado con Cheque</Label>}
                        {document.meta?.matchs?.inMatch?.some(match => match.obligationType === 'factoring') && <Label color="green" size="mini" floating style={{ left: "88%", top: "30%" }}>En Factoring</Label>}
                        {document.meta?.factoring?.cedido && <Label color="green" size="mini" floating style={{ left: "88%", top: "30%" }}>En Factoring</Label>}
                      </>
                    }
                  </div>
                  <div className="d-flex flex-column align-items-center justify-content-center" style={{ position: 'relative', minWidth: '32px' }}>
                    <span
                      className="text-uppercase font-weight-bold position-absolute areaDetailTitle"
                      style={{ top, visibility: 'hidden' }}
                      hidden={index > 0}
                    >
                      &nbsp;
                    </span>
                    <div className="threeDotOptions" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, flexShrink: 0 }}>
                      <OptionsDropDown
                        document={document}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}
